import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home              from "./pages/Home";
import Login             from "./pages/Login";
import Register          from "./pages/Register";
import VerifyOtp         from "./pages/VerifyOtp";
import ForgotPassword    from "./pages/ForgotPassword";
import Dashboard         from "./pages/Dashboard";
import DeclareLoss       from "./pages/DeclareLoss";
import DeclareFound      from "./pages/DeclareFound";
import CertifyTransaction from "./pages/CertifyTransaction";
import MatchingConfirm   from "./pages/MatchingConfirm";
import Matchings         from "./pages/Matchings";
import AgreementResponse from "./pages/AgreementResponse";
import SubmitProof       from "./pages/SubmitProof";
import PayRestitution    from "./pages/PayRestitution";
import DossierDetail     from "./pages/DossierDetail";
import VerifyCertificate from "./pages/VerifyCertificate";
import Notifications     from "./pages/Notifications";
import Profile          from "./pages/Profile";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/"         element={<Home />} />
        <Route path="/login"    element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verifier" element={<VerifyCertificate />} />
        <Route path="/dashboard"            element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/declarer-perte"       element={<ProtectedRoute><DeclareLoss /></ProtectedRoute>} />
        <Route path="/declarer-trouvaille"  element={<ProtectedRoute><DeclareFound /></ProtectedRoute>} />
        <Route path="/certifier"            element={<ProtectedRoute><CertifyTransaction /></ProtectedRoute>} />
        <Route path="/dossiers/:id"         element={<ProtectedRoute><DossierDetail /></ProtectedRoute>} />
        <Route path="/matchings"            element={<ProtectedRoute><Matchings /></ProtectedRoute>} />
        <Route path="/accords/:reference"   element={<ProtectedRoute><AgreementResponse /></ProtectedRoute>} />
        <Route path="/matching/:matchingId" element={<ProtectedRoute><MatchingConfirm /></ProtectedRoute>} />
        <Route path="/preuves/:matchingId"  element={<ProtectedRoute><SubmitProof /></ProtectedRoute>} />
        <Route path="/payer-restitution/:matchingId" element={<ProtectedRoute><PayRestitution /></ProtectedRoute>} />
        <Route path="/notifications"        element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/profil"               element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
